// @flow

// Constants
import { MODEL, OPERATION_TREE, OPERATION_BRANCH } from 'fc-model-sampling-points'

// Libs
import composeOperator from 'fc-operations'

// Exports
export default composeOperator({
  model: MODEL,
  tree: OPERATION_TREE,
  branch: OPERATION_BRANCH,
})
